import { render, staticRenderFns } from "./PleurisyComponent.vue?vue&type=template&id=773ba350&"
import script from "./PleurisyComponent.vue?vue&type=script&lang=ts&"
export * from "./PleurisyComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports